module.exports = __webpack_public_path__ + "img/mz.8e0da65c.png";